<template>
	<div class="mb-2">
		<div v-if="posts.length > 0">
			<div class="row">
                <div v-if="isFetching" class="d-flex flex-column align-items-center">
                    <Loader color="rgb(215, 215, 215)"></Loader>
                    <div style="color:rgb(215, 215, 215);">Loading posts</div>
                </div>
				<div v-for="post in posts" :class="`${columnClasses} mb-2`">
					<FeaturedPost :format="format" :post="post" :key="post.id"></FeaturedPost>
				</div>
			</div>
		</div>
		<template v-if="withLoadMore">
			<div v-if="!isFetching && canLoadMore && loadMoreUrl" class="d-flex justify-content-center">
				<a :href="loadMoreUrl"
				   class="tw-border tw-border-solid tw-border-gray-400 text-uppercase tw-text-black tw-text-2 tw-font-black font-secondary-condensed px-2 py-1 hover:tw-bg-gray-400 hover:tw-text-white mb-2">
					{{loadMoreText.trim() || 'See More'}}
				</a>
			</div>
		</template>
        <div v-if="isFetching" class="d-flex flex-column align-items-center">
            <Loader color="rgb(215, 215, 215)"></Loader>
            <div style="color:rgb(215, 215, 215);">Loading posts</div>
        </div>
	</div>
</template>

<script>
	import axios from 'axios'
	import _get from 'lodash.get'
	import Loader from 'vue-spinner/src/ClipLoader'
	import FeaturedPost from './FeaturedPost'

	export default {
		name: 'featured-posts',
		components: {FeaturedPost, Loader,},
		props: {
			format: {
				type: String,
				default: 'large'
			},
			postIds: {
				type: Array,
				default: [],
				validator: (prop) => prop.every(e => typeof e === 'number'),
			},
			columnClasses: {
				type: String,
				required: true,
			},
			perPage: {
				type: Number,
				default: 0,
			},
			limitTo: {
				type: Array,
				default: [],
			},
			orderBy: {
				type: String,
				default: '',
			},
			inCategories: {
				type: Array,
				default: '',
			},
			from: {
				type: String, // all, categories, or manual
				default: 'all',
			},
			withLoadMore: {
				type: Boolean,
				default: true,
			},
			loadMoreText: {
				type: String,
				default: 'See More',
			},
            loadMoreUrl: {
			    type: String,
                default: '',
            }
		},

		data() {
			return {
				isFetching: true,
				error: false,
				posts: [],
				currentPage: 1,
				totalPages: 1,
			}
		},

		methods: {
			async loadMore() {
				this.isFetching = true
				this.error      = false

				try {
					const response   = await this.nextPageRequest()
					this.currentPage = this.currentPage + 1
					// just in case it changes
					this.totalPages  = parseInt(_get(response, 'headers.x-wp-totalpages', 1))
					this.posts       = [...this.posts, ...response.data]
				} catch (error) {
					this.error = error.message
				} finally {
					this.isFetching = false
				}
			},

			async getTotalNumberOfPages() {
				try {
					return _get(await this.nextPageRequest(), 'headers.x-wp-totalpages', 1)
				} catch (error) {
					return 1
				}
			},

			async fetchInitialPosts() {
				try {
					const response = await axios.get('/wp-json/wp/v2/posts', {
						params: {
							_embed: true,
							include: this.postIds
						}
					})

					this.posts = response.data
				} catch (error) {
					// nothing right now
				} finally {
					this.isFetching = false
				}
			},

			nextPageRequest() {
				const params = {
					// exclude posts we have already retrieved
					exclude: this.currentPostIds,
					per_page: this.perPage || 10,
					orderby: this.orderby || 'date',
					page: this.currentPage,
					_embed: true,
				}

				if (this.from === 'categories' && this.inCategories.length) {
					params.categories = this.inCategories
				}

				if (this.from === 'manual') {
					params.sticky  = false
					params.include = this.postIdsLeftToFetchForManual
				}

				return axios.get('/wp-json/wp/v2/posts', {params})
			}
		},

		computed: {
			currentPostIds() {
				return this.posts.map(post => post.id)
			},
			postIdsLeftToFetchForManual() {
				return this.limitTo.filter(id => !this.currentPostIds.includes(id))
			},
			canLoadMore() {
				return this.currentPage < this.totalPages
			}
		},

		async mounted() {
			console.log( 'test' )
			this.fetchInitialPosts()
			this.totalPages = await this.getTotalNumberOfPages()
		},
	}
</script>
